function Tabs() {
    var autoPlayInterval = null;

    this.setAutoPlayInterval = function(value) { autoPlayInterval = value; };
    this.getAutoPlayInterval = function() { return autoPlayInterval; };

    this.tabsElements = document.querySelectorAll('.tab');
    this.contentsElements = document.querySelectorAll('.tab__content');
    this.init();
}

Tabs.prototype.init = function () {

    var triggers = document.querySelectorAll('.tab__trigger'),
        tab = null,
        trigger = null,
        content = null,
        target = null;

    if (this.tabsElements !== null) {
        var that = this;
        for (var i = 0; i < this.tabsElements.length; i++) {

            tab = this.tabsElements[i];

            tab.addEventListener('click', function (event) {
                var targetFound = that.toogleTab(this, this.dataset.target, true);
            });

        }

        if (triggers !== null) {

            for (var i = 0; i < triggers.length; i++) {

                trigger = triggers[i];

                trigger.addEventListener('click', function (event) {

                    event.preventDefault();
                    var targetFound = false;
                    target = this.dataset.target;

                    // toggle tab class
                    for (var j = 0; j < this.tabsElements.length; j++) {
                        tab = this.tabsElements[j];
                        if (tab.dataset.target == target) {
                            tab.classList.add('active');
                        }
                        else {
                            tab.classList.remove('active');
                        }
                    }

                    // toggle content class
                    for (var k = 0; k < contents.length; k++) {
                        content = contents[k];
                        if (content.classList.contains(target)) {
                            content.classList.add('show');
                            targetFound = true;
                        }
                        else {
                            content.classList.remove('show');
                        }
                    }

                    if (targetFound) {
                        jQuery('html, body').animate({
                            scrollTop: jQuery('.tab__container').offset().top - 10
                        }, 500);
                    }

                });

            }

        }

    }

}

Tabs.prototype.toogleTab = function(element, target, disableAutoPlay = false) {
    var content = null,
        targetFound = false;
    if (!element.classList.contains('active')) {

        element.classList.add('active');

        // toggle tab class
        for (var j = 0; j < this.tabsElements.length; j++) {
            if (this.tabsElements[j] != element) {
                this.tabsElements[j].classList.remove('active');
            }
        }

        // toggle content class
        for (var k = 0; k < this.contentsElements.length; k++) {
            content = this.contentsElements[k];
            if (content.classList.contains(target)) {
                content.classList.add('show');
                targetFound = true;
            }
            else {
                content.classList.remove('show');
            }
        }
    }

    if (disableAutoPlay && this.getAutoPlayInterval() !== null) {
        clearInterval(this.getAutoPlayInterval());
        this.setAutoPlayInterval(null);
    }

    return targetFound;
}

Tabs.prototype.autoPlay = function (selector) {
    var container = document.getElementsByClassName(selector);
    if (container[0]) {
        var children = container[0].children;
        var iterator = 0;
        var maxIteration = children.length;
        var that = this;
        if (maxIteration > 0) {
            that.setAutoPlayInterval(setInterval(function() {
                if (iterator < maxIteration - 1)
                    iterator++;
                else 
                    iterator = 0;

                that.toogleTab(children[iterator], children[iterator].dataset.target);
            }, 5000));
        }
    }
}

export default Tabs;


// WEBPACK FOOTER //
// ./js/components/tabs/index.js